export const COLOURS = {
  primary: {
    black: "#131313",
    pink: "#EAB9BF",
    white: "#FFFFFF",
  },
};
